import {styled} from "@mui/material/styles"
import Grid from "@mui/material/Grid"
import {MastercardLogo, VisaLogo} from "@indebted/assets"

const cardTypesMap = {
	mastercard: MastercardLogo,
	visa: VisaLogo,
}

type CardType = keyof typeof cardTypesMap

function mapCardTypesToSvg(cardTypes: CardType[]) {
	return cardTypes.map((type) => cardTypesMap[type]).filter(Boolean)
}

function AcceptedCards({list = []}: {list: CardType[]}) {
	const cardSvgs = mapCardTypesToSvg(list)

	return (
		cardSvgs.length > 0 && (
			<Container>
				<Grid container spacing={2} direction="row" alignItems="flex-end" style={{justifyContent: "flex-end"}}>
					<Grid style={{marginRight: "5px"}}>
						<CardLogosContainer>
							{cardSvgs.map((El, idx) => (
								<El key={idx} />
							))}
						</CardLogosContainer>
					</Grid>
				</Grid>
			</Container>
		)
	)
}

const Container = styled("div")`
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding-top: 7px;
`

const CardLogosContainer = styled("div")`
	* + * {
		margin-left: 5px;
	}
`

export {AcceptedCards}
